import { Operator } from '@ardoq/api-types';
import { QueryBuilderFilterDefinition, QueryBuilderFilterType } from './types';

export const createSelectFilter = (
  filterId: string,
  filterLabel: string,
  selectOptions: { label: string; value: string }[]
): QueryBuilderFilterDefinition => ({
  id: filterId,
  label: filterLabel,
  filterType: QueryBuilderFilterType.SELECT,
  operators: [Operator.EQUAL, Operator.NOT_EQUAL],
  selectOptions,
});

export const createReferenceTypeFilter = (
  filterId: string,
  filterLabel: string
): QueryBuilderFilterDefinition => ({
  id: filterId,
  label: filterLabel,
  operators: [Operator.EQUAL], // Not actually used. Just included because so many functions require an operator to be there.
  filterType: QueryBuilderFilterType.ASYNC_REFERENCE_TYPE_NAME,
});
